import "../css"
import "../faculty_assignments/js"
import "../enrollments/js"
import "../terms/js"

$(document).on("change", "#select-all-checkbox", function() {
  $(".enrollmentCheckbox").prop("checked", $("#select-all-checkbox").is(":checked"))
})
